export const MONTHS_NO = ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des']

export function toDateString(d) {
  return d.getFullYear() + '-' +
    String(d.getMonth() + 1).padStart(2, '0') + '-' +
    String(d.getDate()).padStart(2, '0')
}

export function formatNumber(n) {
  const parts = parseFloat(n).toFixed(2).split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return parts.join(',')
}

export function formatPercent(v) {
  const r = parseFloat(v).toFixed(2).replace('.', ',')
  return (v >= 0 ? '+' : '') + r + '%'
}

export function priceForUnit(entry, unit) {
  if (unit === 'ounce') return entry.pricePerOunce
  if (unit === 'kg') return entry.pricePerGram * 1000
  return entry.pricePerGram
}

export function percentChange(current, previous) {
  return previous !== 0 ? ((current - previous) / previous * 100) : 0
}
